import { ExpandLeftOutlineIcon } from '@carboncopyco/icons';
import type { StepCount, Tour } from '@carboncopyco/types';
import { ColorHex } from '@carboncopyco/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useRef, useState } from 'react';
import { NavigationControls } from './NavigationControls';

const NAVIGATION_MENU_INDEX = 2147483647; // same as Z_INDEX_TOOLTIP

export type NavigationMenuProps = {
  stepCount: StepCount;
  isTourFirstStep: boolean;
  isTourLastStep: boolean;
  tourSettings: Tour['tourSettings'] | Tour['draftSettings'];
  onNextClick: () => void;
  onBackClick: () => void;
  onRestartClick: () => void;
};

const MENU_COLLAPSE_TIMEOUT = 5000;

export const NavigationMenu = ({
  stepCount,
  isTourFirstStep,
  isTourLastStep,
  tourSettings,
  onNextClick,
  onBackClick,
  onRestartClick,
}: NavigationMenuProps) => {
  const _flags = useFlags();
  const [isExpanded, setIsExpanded] = useState(false);
  const collapseTimeout = useRef<null | ReturnType<typeof setTimeout>>(null);

  const expandMenu = () => {
    if (collapseTimeout.current) {
      clearTimeout(collapseTimeout.current);
    }

    setIsExpanded(true);
  };

  const collapseMenu = () => {
    collapseTimeout.current = setTimeout(() => {
      setIsExpanded(false);
    }, MENU_COLLAPSE_TIMEOUT);
  };

  if (!tourSettings.navigationToggle) {
    return null;
  }

  return (
    <div
      className="flex fixed bottom-0 right-0"
      style={{ zIndex: NAVIGATION_MENU_INDEX }}
      onMouseLeave={collapseMenu}
    >
      {isExpanded ? (
        <NavigationControls
          stepCount={stepCount}
          isTourFirstStep={isTourFirstStep}
          isTourLastStep={isTourLastStep}
          onNextClick={onNextClick}
          onBackClick={onBackClick}
          onRestartClick={onRestartClick}
        />
      ) : (
        <div
          className="mr-3 p-2 bg-ds-natural-600 bg-opacity-90 rounded-t-lg hover:cursor-pointer"
          onMouseEnter={expandMenu}
        >
          <ExpandLeftOutlineIcon color={ColorHex.accent3} />
        </div>
      )}
    </div>
  );
};
